import { Input } from "@material-tailwind/react";
import LoadingButton from "../../components/common/buttons/LoadingButton";
import { Card, CardBody, Typography } from "@material-tailwind/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { otpValidation, otpOnlyForm } from "./authValidations";
import ErrorParagraph from "../../components/common/ErrorParagraph";
import { useMutation } from "react-query";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { handleErrorMessage } from "../../utility";
import { useNavigate } from "react-router-dom";
import { useOnboardingDetailsStore } from "../../store/onboarding/Onboarding";
import Logo from "../../components/common/Logo";
import { useEffect, useRef } from "react";
import { toast } from "react-toastify";

function VerifyPhoneNumber() {
  function handleResend() {
    console.log("resend sms");
    sendOtpMutation.mutate();
  }

  const sentRef = useRef(false);
  const { details } = useOnboardingDetailsStore();
  function submit(data: otpOnlyForm) {
    const responseBody = {
      otp: data.otp,
      email: details!.email,
      phoneNumber: details!.phoneNumber,
    };
    verifyPhoneNumberMutation.mutate(responseBody);
    console.log("form submitted");
  }

  const sendOtpMutation = useMutation(
    () => {
      const phoneNumber = details?.phoneNumber;
      const email = details?.email;
      if (!phoneNumber && email) {
        throw new Error("Phone Number is required to send OTP.");
      }
      return api.post(ApiRoutes.sendOtpPhoneNumber, { phoneNumber, email });
    },
    {
      onSuccess: () => {
        toast.success("OTP sent successfully");
      },
      onError: (error) => {
        handleErrorMessage(error, "Error sending OTP, please try again");
      },
    }
  );

  useEffect(() => {
    if (sentRef.current) return;

    sendOtpMutation.mutate();

    sentRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver<otpOnlyForm>(otpValidation),
    mode: "onChange",
  });

  const navigation = useNavigate();

  const verifyPhoneNumberMutation = useMutation(
    (data: otpOnlyForm) => api.post(ApiRoutes.verifyPhoneNumber, data),
    {
      onSuccess: () => {
        navigation("/verificationSuccessFul");
      },
      onError: (error) => {
        handleErrorMessage(error, "Invalid Otp");
      },
    }
  );

  const { isLoading } = verifyPhoneNumberMutation;

  return (
    <form onSubmit={handleSubmit(submit)}>
      <div className="md:flex w-screen md:h-screen bg-gray-50">
        <div className="invisible md:visible bg-map-background bg-no-repeat w-3/6 relative flex flex-col justify-center items-center">
          <div className="absolute md:top-10 md:left-20">
            <Logo />
          </div>
          <div className="text-4xl">
            <h1>It’s easier to get</h1>
            <h2 className="inline">started with{` `}</h2>
            <h2 className="inline font-extrabold text-primary">GIGM Boat</h2>
          </div>
        </div>

        <div className="ml-20 md:hidden">
          <Logo />
        </div>
        <div className="flex items-center justify-center ">
          <Card
            placeholder={undefined}
            className="md:m-24 m-5 lg:m-36 rounded-md text-center"
          >
            <CardBody placeholder={undefined}>
              <Typography placeholder={undefined} className="font-semibold">
                Verify your Phone Number
              </Typography>
              <Typography placeholder={undefined}>
                Hi there, we just sent a verification code to your provided
                Phone number.
              </Typography>

              <div className="mt-6 text-left font-normal">
                <Input
                  placeholder="Otp"
                  className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                  labelProps={{
                    className: "before:content-none after:content-none",
                  }}
                  crossOrigin={undefined}
                  {...register("otp")}
                />
                {errors.otp && <ErrorParagraph message={errors.otp.message!} />}
              </div>
              <LoadingButton isLoading={isLoading}>
                Enter verification code
              </LoadingButton>
              <span className="flex flex-wrap justify-center mt-9">
                <Typography
                  placeholder={undefined}
                  color="gray"
                  className="font-normal"
                >
                  Didn’t receive the code?
                </Typography>
                <Typography
                  placeholder={undefined}
                  onClick={() => handleResend()}
                  className="ml-2 cursor-pointer"
                  color="red"
                >
                  Resend
                </Typography>
              </span>
            </CardBody>
          </Card>
        </div>
      </div>
    </form>
  );
}

export default VerifyPhoneNumber;
